import {
  call,
  put,
  select,
} from 'redux-saga/effects'
import {
  request,
  error,
} from 'slices/globalSlice'
import { openErrorModal } from 'slices/appSlice'
import dondeAPI from 'api'
import endpoints from 'api/endpoints'

export const getAppState = state => state.app
export const getGlobalState = state => state.global
export const getTravelState = state => state.travel

export function* boiler(
  endpoint,
  { type, options = {}, overrideError = false, errorTitle, errorDismiss },
  ...params
) {
  try {
    yield put(request({ typeLoading: type }))
    const { token = '' } = yield select(getGlobalState)
    if (token?.length) {
      dondeAPI.setHeaders({
        Authorization: `Bearer ${token}`,
        ...options,
      })
      const results = yield call(endpoints[endpoint], ...params)
      if (results?.status >= 200 && results?.status < 300) {
        return {
          status: 'success',
          data: results?.data,
          code: results?.status,
        }
      }
      console.warn('error code: ', results?.data?.error_code || 'unknown')
      const response = {
        code: results?.data?.error_code || results?.data?.status_code,
        detail: results?.data?.detail,
        error: results?.data?.error_code || 'unknown',
        errorData: results?.data,
        typeLoading: type,
        overrideError,
        errorTitle,
        errorDismiss,
      }
      yield put(error(response))
      if (!overrideError) {
        yield put(openErrorModal({
          error: response,
          title: response?.errorTitle,
          dismiss: response?.errorDismiss,
          detail: response?.detail,
        }))
      }
      return {}
    }
    console.warn('token not found, endpoint not executed: ', endpoint)

    return {}
  } catch (e) {
    console.warn('error', e)
    yield put(
      error({ typeLoading: type })
    )
    return { status: 'error' }
  }
}